import type { DurationOption } from "../constants";
import type { MachineNameAndSourceId } from "@common/types/server-list-types";

import { LOOKBACK_AND_POLLING_KEY_PREFIX } from "../constants";

/** The dropdown entry for a stored duration. A duration the list no longer
 *  offers keeps its raw ms as the label, so the stored value stays visible. */
export const findDurationOption = (
  list: readonly DurationOption[],
  ms: number,
  translate: (key: string) => string,
): MachineNameAndSourceId => {
  const option = list.find((d) => d.ms === ms);
  return {
    name: option
      ? translate(`${LOOKBACK_AND_POLLING_KEY_PREFIX}.${option.labelKey}`)
      : String(ms),
    source_id: String(ms),
  };
};
